import xHttp from "../utils/xHttp";
import { getSafeUrl, getUTMParametersFromSessionCache } from "pubweb-smokey/dist/utils/utils";
import { getBaseApiUrl } from "../utils/config";
import { getGAClientId, getKenshooId } from '../utils/utils';

export const submitForm = (formObj) => {
    const url = `${getBaseApiUrl()}leads`;

    const utmParams = getUTMParametersFromSessionCache();

    const formModel = {
        firstName: formObj.firstName ? formObj.firstName.trim() : undefined,
        lastName: formObj.lastName ? formObj.lastName.trim() : undefined,
        emailAddress: formObj.email ? formObj.email.trim() : undefined,
        phoneNumber: formObj.phone ? formObj.phone.trim() : undefined,
        zip: formObj.zip ? formObj.zip.trim() : undefined,
        utmCampaign: utmParams.utm_campaign,
        utmSource: utmParams.utm_source,
        utmMedium: utmParams.utm_medium,
        utmTerm: utmParams.utm_term,
        utmContent: utmParams.utm_content,
        googleClickId: utmParams.gclid,
        bingClickId: utmParams.msclkid,
        facebookClickId: utmParams.fbclid,
        kenshooId: getKenshooId(),
        gaClientId: getGAClientId(),
        originWebUrl: getSafeUrl(),
        originWebPageType: 'clayton-homes-consumer-affairs',
        originWebFormType: 'lead-form',
        originWebFormCategory: null,
        originWebApp: 'clayton-homes-website',
        dataExtension: 'FormActivityCH',
        canEmail: true
    };

    return xHttp.post(url, formModel);
}